module.exports = __webpack_public_path__ + "img/promo-card.8b02f55c.png";